import React from 'react';
import { Button } from '../buttons';
import { Divider } from '../utility';
import { useHistory } from 'react-router';
var CardSale = function (props) {
    var divHeight = '12px';
    var history = useHistory();
    var splitPrice = function (price) {
        if (price.includes('/')) {
            var split = price.split('/');
            return (React.createElement("div", { className: "perMonth-container" },
                React.createElement("span", { className: "price-current" }, split[0]),
                React.createElement("span", { className: "perMonth" }, '/' + split[1])));
        }
        else
            return React.createElement("span", { className: "price-current" }, price);
    };
    return (React.createElement("div", { className: "CardSale " + (props.cardColors ? 'standard-colors' : '') },
        React.createElement("div", { className: "membership-header" },
            React.createElement("span", { className: "membership-text length", style: props.type === 'one-time' ? { display: 'none' } : {} }, props.length || 'Monthly'),
            React.createElement("span", { className: "membership-text type" }, props.title),
            React.createElement("span", { className: "membership-text ", style: props.type === 'one-time' ? { display: 'none' } : {} }, "Membership")),
        React.createElement(Divider, { height: divHeight }),
        React.createElement("div", { className: "subtext" },
            props.subtext,
            React.createElement("div", { className: "description" }, props.description)),
        React.createElement(Divider, { height: divHeight }),
        React.createElement("div", { className: "price-container" },
            React.createElement("span", { className: "price-crossed", style: { visibility: !props.oldPrice ? 'hidden' : 'visible' } }, props.oldPrice || 'placeholder'),
            splitPrice(props.price),
            React.createElement("span", { className: "price-percent-off", style: { visibility: !props.percentOff ? 'hidden' : 'visible' } }, props.percentOff || 'placeholder')),
        React.createElement(Divider, { height: divHeight }),
        React.createElement(Divider, { height: '12px' }),
        React.createElement(Button, { buttonText: props.cta, onClick: function () {
                history.push('/subscribe/' + props.id);
            }, backgroundColor: "white", textColor: "black", fontSize: "14px", hoverEffect: true })));
};
export default CardSale;
//# sourceMappingURL=CardSale.js.map